import {
  Skeleton,
  Typography,
  VertContainer,
  message,
} from '@vertem-core/vertice-ds';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import 'Assets/styles/default/pages/viewRedemption/ViewRedemptionStyles.less';
import { SpotInfos } from './components/spotInfos';
import { SpotSupplierInfo } from './components/spotSupplierInfo';
import { SpotHistory } from './components/spotHistory';
import { SpotProducts } from './components/spotProducts';
import { SpotButtons } from './components/spotButtons';

import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';
import useParticipantSubSegment from 'Hooks/useParticipantSubSegment';
import { loadViewRedemption } from 'redux/Reducers/ViewRedemption/ViewRedemptionSlice';
import ModalCancel from './components/Modal/VertModalCancel';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';
import ModalApprove from 'pages/ViewRedemptionAprove/components/VertModalAprove';
import ModalSendDocument from './components/Modal/ModalSendDocument';
import { SpotNotFound } from 'components/Spot/SpotNotFound';

const ViewRedemptionPage = () => {
  const params = useParams();
  const { callApi } = usePipeContext();
  const [spot, setSpot] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isVisibleModalDocument, setIsVisibleModalDocument] = useState(false);
  const [productsIds] = useState([]);
  const {
    data,
    error,
    isLoading: isLoadingSpotReducer,
  } = useSelector(({ ViewRedemption }) => ViewRedemption);

  const userProfile = useSelector((state) => state.oidc.user.profile);
  const userInfos = useSelector(({ oidc: data }) => data);
  const {
    user: { profile, access_token },
  } = userInfos;

  const userName = profile.username || profile['custom:login'];

  const config = {
    campaignId: userProfile['custom:campaign_id'],
    catalogId: userProfile['custom:catalog_id'],
    participantId: userProfile['custom:participant_id'],
    Authorization: `Bearer ${access_token}`,
    username: userName,
    contentType: 'application/json',
  };

  const participantId = userProfile['custom:participant_id'];
  const [isVisibleModalCancel, setIsVisibleModalCancel] = useState(false);
  const [isVisibleModalApprove, setIsVisibleModalApprove] = useState(false);
  const { isPMO, isManager, isLead } = useParticipantSubSegment();
  const [modalDocument, setModalDocument] = useState({
    type: 1,
    url: null,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(
      loadViewRedemption({
        id: params.id,
      })
    );
  }, [params.id]);

  useEffect(() => {
    setSpot(data);
    setIsError(error);
    setIsLoading(isLoadingSpotReducer);
  }, [data, error, isLoadingSpotReducer]);

  useEffect(() => {
    if (spot && spot.participantId) {
      handleValidateParticipant(spot.participantId, participantId);
    }
  }, [spot, spot?.participantId]);

  const handleValidateParticipant = (participantId, loggedParticipantId) => {
    if (!isPMO)
      if (participantId != loggedParticipantId) return setIsError(true);
  };

  const callModalDocuments = (type, document) => {
    setModalDocument({ type, url: document });
    setIsVisibleModalDocument(true);
  };

  const callModalButton = (action) => {
    if (action === 'approve') {
      setIsVisibleModalApprove(true);
    } else if (action === 'cancel') {
      setIsVisibleModalCancel(true);
    }
  };

  const submitCancel = (values) => {
    setIsVisibleModalCancel(false);
    setIsLoading(true);
    const data = {
      redemptionId: params.id,
      description: values.description,
    };

    redemptionsApiClient
      .put(`/Redemption/Refuse`, data, {
        headers: config,
      })
      .then((res) => {
        navigate('/list-redemptions', {
          state: {
            spotCanceled: true,
            spotId: params.id,
          },
        });
      })
      .catch((err) => {
        console.log('Solicitation Error === ', err);
        message.error(
          'Não foi possível cancelar esta solicitação, valide as informações e tente novamente.'
        );
        setIsLoading(false);
      });
  };

  const approveHierarchy = async (values) => {
    setIsLoading(true);

    const { description } = values;

    if (productsIds.length === 0) {
      message.error(
        'É necessário selecionar ao menos um produto, valide as informações e tente novamente.'
      );
      setIsVisibleModalApprove(false);
      setIsLoading(false);
      return false;
    }

    const _data = {
      redemptionId: spot.id,
      description,
      status: 6,
      productsIds,
    };

    redemptionsApiClient
      .put(`/Redemption/Approve`, _data, {
        headers: config,
      })
      .then((res) => {
        callApi({
          symbol: 'LOAD_BALANCE',
          alias: generateUUID(),
        })


        navigate('/list-redemptions', {
          state: {
            spotApproved: true,
            spotId: params.id,
          },
        });
        setIsVisibleModalApprove(false);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log('approveHierarchy Error === ', err);
        message.error(
          'Não foi possível aprovar a solicitação, valide as informações e tente novamente.'
        );
        setIsVisibleModalApprove(false);
        setIsLoading(false);
      });
  };

  return (
    <VertContainer fluid>
      {isLoadingSpotReducer ? (
        <VertContainer spacingX="regular" spacingY="small">
          <Skeleton active />
        </VertContainer>
      ) : isError || !spot || !spot.id ? (
        <SpotNotFound id={params.id} />
      ) : (
        <VertContainer>
          <div className={'container-view-redemption'}>
            <VertContainer className="container-title-view-redemption">
              <Typography.Text className="title-view-redemption">
                Solicitação #{spot.id}
              </Typography.Text>
            </VertContainer>

            <SpotInfos
              spot={spot}
              isManager={isPMO || isLead}
              callModalDocuments={callModalDocuments}
            />

            <SpotSupplierInfo
              spot={spot}
              callModalDocuments={callModalDocuments}
            />

            <SpotHistory histories={spot.histories} />

            {spot.products && spot.products.length && (
              <SpotProducts spot={spot} />
            )}

            <SpotButtons
              spot={spot}
              isLoading={isLoading}
              callModal={callModalButton}
            />
          </div>
        </VertContainer>
      )}
      <ModalCancel
        isVisible={isVisibleModalCancel}
        setIsVisible={setIsVisibleModalCancel}
        submitCancel={submitCancel}
      />
      <ModalApprove
        isVisible={isVisibleModalApprove}
        setIsVisible={setIsVisibleModalApprove}
        submitApprove={approveHierarchy}
      />
      <ModalSendDocument
        isVisible={isVisibleModalDocument}
        setIsVisible={setIsVisibleModalDocument}
        document={modalDocument}
        spot={spot}
      />
    </VertContainer>
  );
};

export default ViewRedemptionPage;
